import { debounceTime, distinctUntilChanged, pipe } from 'rxjs';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SearchEntity } from 'src/app/core/constants/dropdown-contants';

@Component({
  selector: 'app-rm-lazy-dropdown',
  templateUrl: './rm-lazy-dropdown.component.html',
  styleUrls: ['./rm-lazy-dropdown.component.scss']
})
export class RmLazyDropdownComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() items: any[] = [];
  @Input() totalCount: number = 0;
  @Input() offset: number = 0;
  @Input() paginationLimit: number = 50;
  @Input() control: FormControl<any> = new FormControl('');
  @Input('searchControl') searchControl: FormControl = new FormControl('');

  @Output() loadMore: EventEmitter<void> = new EventEmitter<void>();
  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() selectionChange: EventEmitter<string> = new EventEmitter<string>();

  private _value: any;
  search_entiry = SearchEntity;

  // The function that will be called when the value is set on the form control
  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };
  filterControl: any;

  get value(): any {
    return this._value;
  }

  set value(value: any) {
    this._value = value;
    this.onChange(value);
    this.onTouched();
  }

  // writeValue(value: any): void {
  //   this._value = value;
  //   this.formControl.setValue(value, { emitEvent: false }); // Ensure the formControl value is set correctly
  // }
  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    this.searchControl?.valueChanges?.pipe(
      distinctUntilChanged(),
      debounceTime(SearchEntity.debounce_time)).subscribe((value: string) => {
        this.filterChange.emit(value);
      });
  }

  onScroll() {
    this.loadMore.emit();

    // After loading new items, check if the value is still valid
    // if (this.formControl.value && !this.items.some(item => item.id === this.formControl.value)) {
    //   this.formControl.setValue(null);  // Reset or reselect the appropriate value
    // }
  }
  onSelect(event) {
    this.control.setValue(event);
  }

  onSelectionChange(event) {
    this.selectionChange.emit(event)
  }

}